const dialog = document.querySelector('#ipx-video-detail');
if (dialog) {
  const screen = dialog.querySelector('[data-ipx-video-screen]');
  const heading = dialog.querySelector('[data-ipx-callout-title]');
  const description = dialog.querySelector('[data-ipx-callout-body]');
  const caption = dialog.querySelector('[data-ipx-callout]');
  let player;
  let trigger;
  let active = '';
  const callouts = [...dialog.querySelectorAll('[data-ipx-callout-source]')].map((node) => ({
    start: Number(node.dataset.start),
    title: node.querySelector('h3').textContent,
    body: node.querySelector('p').textContent,
  }));
  const sync = () => {
    const item = callouts.findLast((entry) => player.currentTime >= entry.start);
    if (!item || item.title === active) return;
    active = item.title;
    heading.textContent = item.title;
    description.textContent = item.body;
  };
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('media-gallery .product-media deferred-media button[ref="deferredMediaPlayButton"]');
    if (!button) return;
    const host = button.closest('deferred-media');
    const original = host.querySelector('template')?.content.querySelector('video');
    if (!original) return;
    const source = original.querySelector('source')?.src || original.src;
    if (!/38e94fbca41a48019cef846b2ccca024/.test(source)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    trigger = button;
    for (const video of document.querySelectorAll('video')) video.pause();
    player = original.cloneNode(true);
    player.removeAttribute('autoplay');
    player.removeAttribute('muted');
    player.autoplay = false;
    player.defaultMuted = false;
    player.muted = false;
    player.controls = true;
    player.loop = false;
    player.playsInline = true;
    player.preload = 'metadata';
    player.addEventListener('timeupdate', sync);
    player.addEventListener('loadedmetadata', sync);
    screen.replaceChildren(player);
    active = '';
    caption.hidden = false;
    sync();
    dialog.showModal();
    player.play().catch(() => player.focus());
  }, { capture: true });
  dialog.querySelector('[data-ipx-video-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    player?.pause();
    screen.replaceChildren();
    player = null;
    active = '';
    trigger?.focus();
  });
}





